<!-- Barra de navegación inferior -->
<div class="h-16 fixed bottom-0 left-0 right-0 z-50 bg-[#23476b] shadow-md border-t md:hidden">

  <div class="flex overflow-x-auto whitespace-nowrap px-2">

    <div *ngFor="let item of navItems"
      [ngClass]="item.moduleKey==selectedItem?'bg-slate-500 text-slate-200':''"
      class="min-w-[70px] flex-shrink-0 py-2 flex flex-col items-center justify-center cursor-pointer relative"
      (click)="toggleSubmenu(item)">

      <img [src]="item.currentImgSrc" class="w-6 h-6 mb-1" />

      <span class="text-[11px] text-center px-1"
        [ngClass]="item.moduleKey==selectedItem?'text-slate-200':'text-gray-200'">
        {{ item.label }}
      </span>

    </div>

  </div>

  <!-- Submenu -->
  <div *ngIf="activeSubmenuItem?.subMenu"
       class="fixed bottom-16 left-0 right-0 bg-white shadow-md border-t z-[99999]">

    <div class="flex flex-col divide-y divide-gray-200">
      <div *ngFor="let sub of activeSubmenuItem.subMenu"
        class="px-4 py-3 text-sm text-gray-700 active:bg-gray-200 cursor-pointer text-center"
        (click)="navigateTo(sub)">
        {{ sub.label }}
      </div>
    </div>

  </div>
</div>